module.exports = __webpack_public_path__ + "static/media/pexels-cottonbro-4622423.91e9921c.jpg";